<template>
  <div 
    v-if="team.approvers && team.approvers.length"
    class="BcApprovalTeamRow bg-white w-full flex flex-row justify-start items-center px-4 py-3 gap-2.5 border-b border-gray-400 hover:bg-gray-100 cursor-pointer"
    @click.stop.prevent="showApprovers = !showApprovers"
  >
    <aw-icon 
      icon="team" 
      class="w-6 h-6 text-gray-400"
    />
    <p class="text-sm font-semibold">
      {{ team.name }}
    </p>
    <bc-approval-graph
      class="ml-auto"
      :stats="team.stats"
    />
    <button class="BcApprovalTeamRow__ExpandButton text-gray-400">
      <aw-icon 
        icon="chevron-down" 
        class="w-6 h-6 transform"
        :class="{'rotate-180' : showApprovers}"
      />
    </button>
  </div>
  <template v-if="showApprovers">
    <bc-approval-approver-row
      v-for="(approver, i) in team.approvers"
      :key="i"
      :approver="approver"
    />
  </template>
</template>

<script>
export default {
  props: {
    team: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showApprovers: false,
    }
  },
  watch: {
    'team.open': {
      handler( newVal ) {
        this.showApprovers = newVal
      },
    }
  }
}
</script>

<style lang="scss" scoped>
.BcApprovalTeamRow {
  min-height: 3.25rem;

  svg {
    min-width: 1.5rem;
  }

  &:hover {
    .BcApprovalTeamRow__ExpandButton {
      @apply text-gray-800;
    }
  }
}
</style>
